require("./bootstrap");
var headerNotificationModule = require("./header-notification");
var filtersModule = require("./filters");
var productFilterModule = require("./product-filter");
var maintenanceModule = require("./maintenance");
var priceToggleModule = require("./price-toggle");
var darkModeModule = require("./darkMode");
var quickQuotationOverviewModule = require("./quick-quotation-overview");
import intlTelInput from "intl-tel-input";

$(document).ready(function () {
    var darkMode = new darkModeModule();
    darkMode.init();

    var quickQuotationOverview = new quickQuotationOverviewModule();
    quickQuotationOverview.init("#header", "#sticky-product-header");

    var headerNotification = new headerNotificationModule();
    headerNotification.init();

    var productFilter = new productFilterModule(new filtersModule());
    productFilter.listen();

    var maintenance = new maintenanceModule(new filtersModule());
    maintenance.render();

    var priceToggle = new priceToggleModule();
    priceToggle.listen();

    $(".js-nav-scroller").each(function () {
        new HsNavScroller($(this)).init();
    });

    /**
     * Hide scroll to button when target is found
     */
    $("#call-to-action-container").on("scroll", function () {
        var element = document.querySelector("#submit-your-review");
        var position = element.getBoundingClientRect();

        if (position.top >= 0 && position.bottom <= window.innerHeight) {
            $(".u-go-to-modern").fadeOut();
        }
    });

    document.querySelectorAll(".u-go-to-modern").forEach((anchor) => {
        anchor.addEventListener("click", function (e) {
            e.preventDefault();
            document.querySelector(this.getAttribute("href")).scrollIntoView({
                behavior: "smooth",
            });
        });
    });

    /**
     * Added scroll state to body
     */
    $(window).scroll(function () {
        if ($(window).scrollTop() > 50 && !$("body").hasClass("scrolled")) {
            $("body").addClass("scrolled");
        }
        if ($(window).scrollTop() < 50) {
            $("body").removeClass("scrolled");
        }
    });

    /**
     * Handle show if filled
     */
    $("[data-show-if-filled]").each(function () {
        var $this = $(this);
        var selector = $this.attr("data-show-if-filled");
        $(selector).on("change", function () {
            var $selector_this = $(this);
            if ($selector_this.val()) {
                $this.removeClass("d-none");
            } else {
                $this.addClass("d-none");
            }
        });
    });

    $("[data-on-click-fill]").each(function () {
        var $this = $(this);
        $this.on("click", function (event) {
            event.preventDefault();
            var settings = $this.attr("data-on-click-fill").split(";");
            $.each(settings, function (index, value) {
                var options = value.split("|");
                $(options[0]).val(options[1]);
                $(options[0]).trigger("change");
            });
        });
    });

    $("#quantity_input").on("change", function () {
        var quantity = $(this).val();
        $("[data-one-ear]").each(function () {
            if (quantity == 2) {
                $(this).text($(this).attr("data-two-ears"));
            } else {
                $(this).text($(this).attr("data-one-ear"));
            }
        });
    });

    $("[data-on-click-toggle]").each(function () {
        var $this = $(this);
        $this.on("click", function () {
            var $clicked = $(this);
            var group = $clicked.attr("data-on-click-toggle");
            var options = group.split("|");
            $('[data-on-click-toggle="' + group + '"]').removeClass(options[1]);
            $clicked.addClass(options[1]);
        });
    });

    function validateDataVisableIfIsTrue($element, settings, operator) {
        var show = false;
        var matches = 0;

        $.each(settings, function (index, value) {
            var options = value.split("=");
            if ($(options[0]).val() == options[1]) {
                matches++;
            }
        });

        if (matches > 0 && operator == "OR") {
            show = true;
        } else if (matches == settings.length && operator == "AND") {
            show = true;
        } else if (matches > 0 && !operator) {
            show = true;
        }

        if (show === true) {
            if ($element.hasClass("d-none")) {
                var loader_selector = $element.attr("data-visable-if-loader");
                if (loader_selector) {
                    $element.addClass("block-is-loading");
                    $(loader_selector).removeClass("d-none");
                    $(loader_selector).show();
                    setTimeout(function () {
                        $(loader_selector).fadeOut("slow", function () {
                            $(loader_selector).addClass("d-none");
                            $element.removeClass("block-is-loading");
                        });
                    }, 800);
                }
                $element.removeClass("d-none");
            }
        } else {
            $element.addClass("d-none");
        }
    }

    $("[data-visable-if]").each(function () {
        var $this = $(this);
        var settings = $this.attr("data-visable-if").split(";");
        var operator =
            settings.length > 1 ? $this.attr("data-visable-if-operator") : null;

        validateDataVisableIfIsTrue($this, settings, operator);

        $.each(settings, function (index, value) {
            var options = value.split("=");
            $(options[0]).on("change", function () {
                validateDataVisableIfIsTrue($this, settings, operator);
            });
        });
    });

    $("[data-hide-when-checked]").on("change", function () {
        var $this = $(this);
        var selector = $this.attr("data-hide-when-checked");
        var $target = $($this.attr("data-show-loader"));
        if ($this.prop("checked")) {
            $(selector).hide();
        } else {
            $(selector).show();
        }

        $target.addClass("block-is-loading");
        $target.find(".full-block-loader").removeClass("d-none");

        setTimeout(function () {
            $target.removeClass("block-is-loading");
            $target.find(".full-block-loader").addClass("d-none");
        }, 1000);
    });

    $("[data-toggle-element]").on("click", function (event) {
        event.preventDefault();
        var $this = $(this);
        var all_element_selector = $this.attr("data-toggle-element");
        var element_to_show = $this.attr("data-toggle-this-element");
        var active_text = $this.attr("data-toggle-active-text");
        var inactive_text = $this.attr("data-toggle-inactive-text");
        var is_active = $this.hasClass("toggle-activated");

        $('[data-toggle-element="' + all_element_selector + '"]').each(
            function () {
                var $_this = $(this);
                $_this.removeClass("toggle-activated");
                $($_this.attr("data-toggle-this-element")).addClass("d-none");
                $_this.html(inactive_text);
            }
        );

        if (!is_active) {
            $this.addClass("toggle-activated");
            $this.html(active_text);
            $(element_to_show).removeClass("d-none");
        }
    });
    $(".zipcode-filter-field").on("focus", function () {
        $(".zipcode-filter-field-container").addClass("focus");
    });
    $(".zipcode-filter-field").on("blur", function () {
        $(".zipcode-filter-field-container").removeClass("focus");
    });
    $(".zipcode-filter-field").on("keydown", function (event) {
        if (event.keyCode < 48 || event.keyCode > 57) {
            event.preventDefault();
            return;
        }
    });
    $(".zipcode-filter-field").on("keyup", function (event) {
        var $input_field = $(this);
        var zipcode_length = $input_field.val().length;
        if (zipcode_length >= 4) {
            $input_field.blur();
            $location_overview = $("#location-overview");
            $loader = $location_overview.find(".full-block-loader");
            $loader.removeClass("d-none");

            setTimeout(function () {
                $loader.addClass("d-none");
            }, 1000);
        }
    });

    $("body").on("click", ".clickable-row", function () {
        window.location = $(this).data("href");
    });

    $("body").on("click", ".iti__flag-container", function () {
        var $container = $(this).parents(
            ".country-phonenumber-selector-container"
        );
        var $list = $container.find(".iti__country-list");
        if ($list.hasClass("iti__hide")) {
            $list.removeClass("iti__hide");
        } else {
            $list.addClass("iti__hide");
        }
    });

    $("body").on("click", ".garden-frame-360-loader", function (e) {
        var $this = $(this);
        $("#" + $this.attr("aria-controls")).html(
            '<iframe class="iframe_360" src="' +
                $this.attr("data-frame") +
                '"></iframe>'
        );
    });

    $("body").on("click", "[data-dial-code]", function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $clicked = $(this);
        var $container = $clicked.parents(
            ".country-phonenumber-selector-container"
        );
        var $country_code_input = $container.find(".js-country-code-input");
        $country_code_input.val($clicked.attr("data-dial-code"));
        $country_code_input.trigger("change");
        $country_code_input.trigger("update");

        Livewire.dispatch("countryCodeChanged", $clicked.attr("data-dial-code"));

        var $list = $container.find(".iti__country-list");
        $list.addClass("iti__hide");

        var $active_flag = $container.find(".iti__selected-flag");
        $active_flag.attr(
            "title",
            $clicked.find(".iti__country-name").text() +
                ": " +
                $clicked.find(".iti__dial-code").text()
        );
        $active_flag.attr("aria-activedescendant", $clicked.attr("id"));
        $active_flag.find(".iti__flag").remove();

        var $flag = $clicked.find(".iti__flag-box .iti__flag").clone();
        $active_flag.prepend($flag);
    });

    Livewire.on("hideModal", (modalId) => {
        $(modalId).modal("hide");
    });

    var rangeReady = false;

    new HSUnfold(".js-hs-unfold-invoker-price", {
        afterOpen() {
            if (!rangeReady) {
                // INITIALIZATION OF ION RANGE SLIDER
                // =======================================================
                $(".js-ion-range-slider").each(function () {
                    var ionRangeSlider =
                        $.HSCore.components.HSIonRangeSlider.init($(this));
                });

                rangeReady = true;
            }
        },
    }).init();

    // INITIALIZATION OF CHARTJS
    // =======================================================
    $(".js-chart").each(function () {
        console.log("js-chart");
        var chart = $.HSCore.components.HSChartJS.init($(this));
    });

    // INITIALIZATION OF SELECT2
    // =======================================================
    $(".js-custom-select").each(function () {
        var select2 = $.HSCore.components.HSSelect2.init($(this));
    });

    $(".navbar-toggler").on("click", function () {
        $("body").toggleClass("mobile-menu-open");
    });
});
